export const GET_VEHICLE_MAINTENANCE_PROFILES = `V3GET_VEHICLE_MAINTENANCE_PROFILES`;
export const CU_VEHICLE_MAINTENANCE_PROFILE = "V3_CU_VEHICLE_MAINTENANCE_PROFILE";
export const GET_VEHICLE_MAINTENANCE_STATES = "V3_GET_VEHICLE_MAINTENANCE_STATES";